import { connect } from 'react-redux';

import { BuilderLayout, IBuilderLayoutStateProps } from '.';
import { IState } from '../../../store';
import { MODERATION_STATUS_TYPES } from '../../../types';

function mapStateToProps(state: IState): IBuilderLayoutStateProps {
  const {
    villageData: {
      village: { builder },
    },
  } = state;

  return {
    builderName: builder && builder.moderationStatus === MODERATION_STATUS_TYPES.Published ? builder.name : '',
    logoUrl: builder?.logoUrl,
  };
}

export const BuilderLayoutContainer = connect<IBuilderLayoutStateProps>(mapStateToProps)(BuilderLayout);
